// Modules
import './StatusOrder.scss';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';

// Button
import '@ingka/svg-icon/style.scss';
import '@ingka/button/style.scss';
import '@ingka/focus/style.scss';
import Button from '@ingka/button';
import { selectSelectedTopic } from 'Store/selectors';
import { useGetTopicQuery } from 'Services/api';
import { sendAnalyticEvent } from '../../utils/analytics';
import RichTextEditor from '../RichTextEditor/RichText.jsx';
import RecommendedLabel from '../recommendedLabel/RecommendedLabel.jsx';

const StatusOrder = ({ heading, content, label, urlButton }) => {
    const { data: pages } = useGetTopicQuery();

    const selectedTopic = useSelector(selectSelectedTopic);

    const topic = () => pages.topics.find(({ id }) => id === selectedTopic)?.topicHeadline;

    const sendToAnalytics = () => {
        sendAnalyticEvent({
            action: topic(),
            category: `CSP-6-${label}`,
            label: 'Recommended-Topic',
        });
    };

    const handleClick = () => {
        if (topic() && label) sendToAnalytics();
    };

    return (
        <Fragment>
            <div className="status-order">
                <RecommendedLabel />
                <h2 className="status-order__heading">{heading}</h2>

                {content && <RichTextEditor data={content} style={'status-order__description'} />}
                {/* the URL is dummy for now */}
                <Button
                    type="emphasised"
                    className="status-order__btn"
                    onClick={handleClick}
                    href={urlButton}
                >
                    {label}
                </Button>
            </div>
        </Fragment>
    );
};

StatusOrder.propTypes = {
    heading: PropTypes.string,
    content: PropTypes.object,
    label: PropTypes.string,
    urlButton: PropTypes.string,
};

export default StatusOrder;
